import axios from "axios";

export const GET_PAGE = "v1/pages";

export function getPage(pageSlug) {
  return axios.get(`${GET_PAGE}/${pageSlug}`);
}
